<template>
  <div >
    <div class="d-flex flex-column" style="height:100%;background:#f7f7f7" id="page3">
      <!-- <v-header></v-header> -->
      <div class="d-flex align-items-center" style="height:80px;padding-left:6%;padding-right:9%" id="header">
      	<div class="d-flex align-items-center justify-content-between width-p100" style="height:80px" >
      		<a href="#"  class="d-flex align-items-center">
      			<img src="https://image.xingqubaike.com:8443/minicard/ucenter/personcenter/login/logo.png" style="width:40px;height:40px" >
      			<div class="mar-left10 fz26 font-weight-bold">橙贝商城</div>
      		</a>
          <i class="el-icon-s-fold fz30 header-more c-fe9120" v-on:click="openMore()"></i>
      		<div class="top-nav d-flex align-items-center aaa" style="height:80px">
      			<a href="javascript:void(0)" v-on:click="scrollToCmtList('git')" class="nav_a">礼物兑换</a>
      			<a href="javascript:void(0)" v-on:click="scrollToCmtList('vip')" class="nav_a">会员专享</a>
      			<a href="javascript:void(0)" v-on:click="scrollToCmtList('group')" class="nav_a">团购活动</a>
      			<a href="javascript:void(0)" v-on:click="scrollToCmtList('boutique')" class="nav_a">精品圈子</a>
      			<a href="javascript:void(0)" v-on:click="scrollToCmtList('hotGoods')" class="nav_a">热卖宝贝</a>
      			<a href="javascript:void(0)" v-on:click="scrollToCmtList('fxCircle')" class="nav_a">分销圈子</a>
      			<a href="javascript:void(0)" v-on:click="scrollToCmtList('fxGoods')" class="nav_a">分销宝贝</a>
      			<a href="javascript:void(0)" v-on:click="scrollToCmtList('store')" class="nav_a">精选店铺</a>
      		</div>
      	</div>
      </div>

      <el-drawer
        title="橙贝商城"
        custom-class="more"
        :visible.sync="drawer"
        :with-header="false">
        <a href="#"  class="d-flex align-items-center" style="margin: 30px auto;width: 160px;margin-top: 50px;">
        	<img src="https://image.xingqubaike.com:8443/minicard/ucenter/personcenter/login/logo.png" style="width:40px;height:40px" >
        	<div class="mar-left10 fz22 font-weight-bold c-000000">橙贝商城</div>
        </a>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="scrollToCmtList('git')">礼物兑换</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="scrollToCmtList('vip')">会员专享</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="scrollToCmtList('group')">团购活动</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="scrollToCmtList('boutique')">精品圈子</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="scrollToCmtList('hotGoods')">热卖宝贝</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="scrollToCmtList('fxCircle')">分销圈子</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="scrollToCmtList('fxGoods')">分销宝贝</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="scrollToCmtList('store')">精选店铺</div>
      </el-drawer>


    	<div class="content" style="margin-top: 100px;">
        <div class="posters">
          <div class="swiper_box posters">
          	<swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
          		<swiper-slide class="slide-1" v-for="(item,index) in objInfo.imgList" :key="index">
          			<div class="posters" v-on:click="toDetailTop(item.id,item.openid,item.objType)" :style="{'background-image':'url('+ item.ip + item.url +')'}">
          			  <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
          			    <div style="width: 100%;height:2vw"></div>
          			    <div class="title">{{item.title}}</div>
          			    <div class="secondTitle">{{item.secondTitle}}</div>
          			    <div class="userInfo">
          			      <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
          			      <div class="username">{{item.nickname}}</div>
          			    </div>
          			  </div>
          			</div>
          		</swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
          	</swiper>
          </div>
        </div>

        <el-form ref="form">

          <el-form-item label="所在地区">
             <el-select v-model="valueProvince"
             placeholder="请选择省"
             @change="changeProvince"
             style="width:150px">
              <el-option
                v-for="item in provinceList"
                :key="item.cityid"
                :label="item.cityname"
                :value="item.cityid">
              </el-option>
            </el-select>
            <el-select v-model="valueCity"
                      placeholder="请选择市"
                      @change="changeCity"
                      style="width:150px">
              <el-option
                v-for="item in cityOptions"
                :key="item.cityid"
                :label="item.cityname"
                :value="item.cityid">
              </el-option>
            </el-select>
            <el-select v-model="valueOrigin"
                      placeholder="请选择区"
                      @change="changeOrigin" style="width:150px">
              <el-option
                v-for="item in originOptions"
                :key="item.cityid"
                :label="item.cityname"
                :value="item.cityid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>


        <!-- 礼物兑换 -->
        <div id="git">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">礼物兑换</div>
            <div class="fz16 mar-top5 c-c97b28 flex-fill">"限时限量"会员礼物兑换中...</div>
          </div>
          <template v-for="(item,index) in objInfo.giftList">
            <!-- <div class="bigImg" v-on:click="toDetail(item.id,item.openid)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div> -->
            <div class="items">
              <div v-on:click="toDetail(item.id,item.openid)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 会员专享圈子 -->
        <div id="vip" style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">会员专享圈子</div>
            <div class="fz16 mar-top5 c-c97b28 flex-fill">"限时限量"会员抢购中...</div>
          </div>
          <template v-for="(item,index) in objInfo.vipCirleList">
            <div class="bigImg" v-on:click="lookMore(layerShow)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="lookMore(layerShow)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 会员专享宝贝 -->
        <div id="vip" style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">会员专享宝贝</div>
            <div class="fz16 mar-top5 c-c97b28 flex-fill">"限时限量"会员抢购中...</div>
          </div>
          <template v-for="(item,index) in objInfo.vipGoodsList">
            <div class="bigImg" v-on:click="toDetail(item.id,item.openid)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="toDetail(item.id,item.openid)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 圈子团购活动 -->
        <div id="group" style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">圈子团购活动</div>
          </div>
          <template v-for="(item,index) in objInfo.groupBuyCirlcleList">
            <div class="bigImg" v-on:click="lookMore(layerShow)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="lookMore(layerShow)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 宝贝团购活动 -->
        <div style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">宝贝团购活动</div>
          </div>
          <template v-for="(item,index) in objInfo.groupBuyList">
            <div class="bigImg" v-on:click="toDetail(item.id,item.openid)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="toDetail(item.id,item.openid)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 精品圈子 -->
        <div id="boutique" style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">精品圈子</div>
            <div class="fz16 mar-top5 c-c97b28 flex-fill">"限时限量"快来加入...</div>
          </div>
          <template v-for="(item,index) in objInfo.circleList">
            <div class="bigImg" v-on:click="lookMore(layerShow)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="lookMore(layerShow)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 热卖宝贝 -->
        <div id="hotGoods" style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">热卖宝贝</div>
            <div class="fz16 mar-top5 c-c97b28 flex-fill">"限时限量"快来抢购...</div>
          </div>
          <template v-for="(item,index) in objInfo.sgoondList">
            <div class="bigImg" v-on:click="toDetail(item.id,item.openid)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="toDetail(item.id,item.openid)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 圈子分销 -->
        <div id="fxCircle" style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">圈子分销</div>
          </div>
          <template v-for="(item,index) in objInfo.fxcircleList">
            <div class="bigImg" v-on:click="lookMore(layerShow)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="lookMore(layerShow)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 宝贝分销 -->
        <div id="fxGoods" style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">宝贝分销</div>
          </div>
          <template v-for="(item,index) in objInfo.fenxiaoGoods">
            <div class="bigImg" v-on:click="toDetail(item.id,item.openid)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="toDetail(item.id,item.openid)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

        <!-- 精选店铺 -->
        <div id="store" style="clear: left;">
          <div class="d-flex align-items-center pad-top20 pad-left5 pad-bottom20">
            <div class="vativalLine bgc-c97b28"></div>
            <div class="fz26 font-weight-bold mar-left20 mar-right20 c-c97b28">精选店铺</div>
          </div>
          <template v-for="(item,index) in objInfo.storeList">
            <div class="bigImg" v-on:click="lookMore(layerShow)" :style="{'background-image':'url('+ item.ip + item.url +')'}" v-if="index==0">
              <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);">
                <div style="width: 100%;height:2vw"></div>
                <div class="title">{{item.title}}</div>
                <div class="userInfo">
                  <img :src="item.headIp+item.headUrl" class="imgFit" style="width:3vw;height: 3vw;border-radius: 50px;float: left;border: 1px solid #f7f7f7;"/>
                  <div class="username">{{item.nickname}}</div>
                </div>
              </div>
            </div>
            <div class="items" v-if="index>0">
              <div v-on:click="lookMore(layerShow)">
                <div class="itemImg">
                  <img :src="item.ip + item.url" class="itemImg"/>
                </div>
                <div class="titlePad twoLine" style="height: 32px;">{{item.title}}</div>
                <div class="" style="padding:0 15px 20px 15px">
                  <div class="d-flex align-items-center">
                    <template v-if="item.swich!=0 || (item.swich==1 && item.ticketInfo.price==0)">
                      <img src="https://image.xingqubaike.com:8443/minicard/home/weekly/02jinbi.png" style="width:20px;height:20px;border-radius:50%;margin-right:6px"/>
                    </template>

                    <div class="" style="color:#fe7f0c;height: 20px;" >{{item.ticketInfo.orangeShell}}橙贝</div>
                  </div>
                  <div class="mar-top5">原价￥ <div style="text-decoration: line-through;display: inline-block;">{{item.ticketInfo.price}}</div>元</div>
                </div>
              </div>
            </div>
          </template>

        </div>

      </div>
      <div style="font-size:18px;color:#ff9a2e;font-weight: bolder;text-align: center;padding:20px 0 55px 0;cursor: pointer;" v-on:click="lookMore(layerShow)">查看更多</div>
      <v-footer></v-footer>
    </div>
    <div style="width:100%;height:100%;position: fixed;top:0;left:0;z-index:10;background:rgba(0,0,0,0.5)" v-if="layerShow" class="d-flex flex-column align-items-center justify-content-center">
      <div style="width:210px;background:#fff" class="d-flex align-items-center justify-content-center flex-column pad-left5 pad-right5 pad-top10 pad-bottom10">
        <img src="../../assets/img/index/miniProjectImg.jpg" style="width:200px;height:200px;" />
        <div class="fz14 c-333333 mar-top5">请扫码前往小程序操作</div>
        <div class="c-999999 mar-top10" style="font-size:10px">兴趣百科-再小的兴趣也是同好</div>
      </div>
      <img src="../../assets/img/index/close.png" style="width:25px;height:25px;margin-top:25px" v-on:click="lookMore(layerShow)"/>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import header from '@/pages/pc/header';
import footer from '@/pages/pc/footer';
import jsonData from '../../../static/js/city.js';
import { animate } from 'popmotion'
export default {
  name: 'pcIndex',
  components:{
    'v-header':header,
    'v-footer':footer
  },
  data () {
    return {
      objInfo:{},
      layerShow:false,
      swiperOptionTop: {
        effect:'fade',
        loop:false,
        loopedSlides:1,
        autoplay:true,
        // zoom: true,//双击放大
        navigation: {
        	nextEl: '.swiper-button-next',
        	prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        },
      },
      provinceList: [], // 省列表
      cityList: [], // 市列表
      originList: [], // 区列表
      valueProvince: 4524130, // 所选的省
      valueCity: 4524271, // 所选的市
      valueOrigin: 4623017, // 所选的区
      cityOptions: [], // 市下拉框数据
      originOptions: [],// 区下拉框数据
      drawer: false
    }
  },
  mounted(){//页面加载后，调用接口数据
    var that = this;
    that.getData(0);
    that._getJsonData();
    if(that.$route.params.type){
      setTimeout(function() {that.scrollToCmtList(that.$route.params.type)}, 1000);
    }

  },
  methods:{
      lookMore:function(param){//点击查看更多方法
        this.layerShow=!param
      },

      openMore: function(){
        this.drawer=true
      },

      toDetail:function(id,openid){//点击日记跳转到详情页
        console.log("日记id是："+id)
        this.$router.push({ name: 'goodsDetail',params:{id:id,openid:openid}})
      },

      toDetailTop:function(id,openid,type){//点击海报跳转到详情页
        if(type=="circle"){
          this.layerShow=true
        }else{
          this.$router.push({ name: 'goodsDetail',params:{id:id,openid:openid}})
        }

      },

      //获取数据列表
      getData:function(id){
        var data = {}
        data.provinceid = this.valueProvince
        data.cityid =this.valueCity
        data.areaid = this.valueOrigin
        data.openid = 'oG2O94unQXotbaZixnoW0Dcc3Ktk'
        axios.post('https://www.xingqubaike.com/wx/handshake-provider-xswl-home/shop/goods/getShopRecomendGoods',data).then(response => {
            this.objInfo=response.data.result.obj
        }, response => {
            console.log("error");
        });
      },

      creatQrCode() {
        var qrcode = new qRCode1(this.$refs.qrCodeUrl, {
            text: 'https://www.xingqubaike.com/ewm/&1&9&'+id + "&1&"+openid, // 需要转换为二维码的内容
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: qRCode1.CorrectLevel.H
        })
      },

      // 初始化省市区数据
      _getJsonData() {
        this.provinceList = jsonData.getDateByLevelType(1)
        this.cityList = jsonData.getDateByLevelType(2)
        this.originList = jsonData.getDateByLevelType(3)
        this.cityOptions = jsonData.getCityByFatherid(2,4524130)
        this.originOptions = jsonData.getCityByFatherid(3,4524271)

        for (let index in this.provinceList) {
          this.provinceList[index].children = [];
          for (let index1 in this.cityList) {
            if (this.provinceList[index].cityid === this.cityList[index1].fatherid) {
              this.provinceList[index].children.push(this.cityList[index1])
            }
          }
        }
        for(let item1 in this.cityList) {
          this.cityList[item1].children = [];
          for(let item2 in this.originList) {
            if (this.originList[item2].fatherid === this.cityList[item1].cityid) {
              this.cityList[item1].children.push(this.originList[item2])
            }
          }
        }
      },

      // 选择省
      changeProvince(val) {
        this.valueProvince = val;
        this.provinceList.forEach((province, index) => {
          if (val === this.provinceList[index].cityid) {
             this.cityOptions = this.provinceList[index].children
             //this.originOptions = this.provinceList[index].children[0].children
             this.valueCity = ''
             this.valueOrigin = ''
             // 如果选中省之后想市区默认选中
            // this.valueCity = this.provinceList[index].children[0].value
            // this.valueOrigin = this.provinceList[index].children[0].children[0].value
          }
        })
      },
      // 选择市
      changeCity(val) {
        this.valueCity = val;
        this.cityList.forEach((city, index) => {
          if (val === this.cityList[index].cityid) {
            this.originOptions = this.cityList[index].children
            this.valueOrigin = ''
            //如果选中市之后默认区选中
            // this.valueOrigin = this.cityList[index].children[0].value
          }
        })
      },
      // 选择区
      changeOrigin(val) {
        this.valueOrigin = val
        this.getData(0);
      },


      // 滚动到评论的列表区域
      scrollToCmtList(type) {
        this.drawer=false
        // 1. 当前滚动条的位置
        const now = window.scrollY
        // 2. 目标位置（文章信息区域的高度）
        const dist = document.querySelector('#'+type).offsetTop

        // 3. 实现滚动动画
        animate({
          from: now, // 当前的位置
          to: dist,  // 目标位置
          onUpdate: latest => window.scrollTo(0, latest)
        })
      },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
  @import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  .titlePad{padding:0 20px;margin:15px 0}
  #header{background:#FFFFFF;position: fixed;top: 0;width: 85%;z-index: 9;}
  #header a{color:#333333}
  //#page3 #shop{color:#fe7f0c;border-bottom:3px solid #fe7f0c;}
  .vativalLine{height:40px;width:5px;border-radius: 5px;margin-top:5px}
  .bgc-c97b28{background:#c97b28}
  .c-c97b28{color:#c97b28}
  .nav_a{height:100%;display: flex;align-items: center}
  .more{width: 50vw !important;}
  @media screen and (min-width:1430px){
      .header-more{display: none;}
  }
  @media screen and (max-width:1430px){
      .aaa{display: none !important;}
  }
  @media only screen and (min-width:768px) and (max-width:1279px){
    .posters{width: 100%;height: 18vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .itemImg{width:100%;height: 13vw;}
    .bigImg{width: 98%;height: 14vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .content{width: 50%;margin:30px auto}
    .title{margin: 0 30px;font-size: 26px;color: #f7f7f7;}
    .userInfo{margin-left: 20px;line-height: 3vw;position: absolute;bottom: 1vw; left: 0;}
    .username{float: left;margin-left: 8px;font-size: 20px;color: #f7f7f7;}
    .secondTitle{float: left;margin-left: 30px;font-size: 21px;color: #f7f7f7;margin-top: 1vw;}
    .items{border:1px solid #e8e8e8;margin:0 auto 20px;height:auto;overflow:auto;width:48%;border-radius:8px;float: left;margin-right: 1%;}
  }
  @media only screen and (min-width:1279px){
    .posters{width: 100%;height: 18vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .itemImg{width:100%;height: 8vw;}
    .bigImg{width: 98%;height: 14vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .content{width: 50%;margin:30px auto}
    .title{margin: 0 30px;font-size: 30px;color: #f7f7f7;}
    .userInfo{margin-left: 30px;line-height: 3vw;position: absolute;bottom: 1vw; left: 0;}
    .username{float: left;margin-left: 10px;font-size: 24px;color: #f7f7f7;}
    .secondTitle{float: left;margin-left: 30px;font-size: 24px;color: #f7f7f7;margin-top: 0.8vw;}
    .items{border:1px solid #e8e8e8;margin:0 auto 20px;height:auto;overflow:auto;width:31%;border-radius:8px;float: left;margin-right: 2%;}
  }
  @media only screen and (max-device-width:767px){
    .posters{width: 100%;height: 35vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .itemImg{width:100%;height: 25vw;}
    .bigImg{width: 98%;height: 30vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .content{width: 96%;margin:30px auto}
    .title{margin: 0 30px;font-size: 26px;color: #f7f7f7;}
    .userInfo{margin-left: 20px;line-height: 3vw;position: absolute;bottom: 3vw; left: 0;}
    .username{float: left;margin-left: 8px;font-size: 20px;color: #f7f7f7;}
    .secondTitle{float: left;margin-left: 30px;font-size: 21px;color: #f7f7f7;margin-top: 2vw;}
    .items{border:1px solid #e8e8e8;margin:0 auto 20px;height:auto;overflow:auto;width:48%;border-radius:8px;float: left;margin-right: 1%;}
  }
  
  @media only screen and (max-width:767px){
    .posters{width: 100%;height: 35vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .itemImg{width:100%;height: 25vw;}
    .bigImg{width: 98%;height: 30vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .content{width: 96%;margin:30px auto}
    .title{margin: 0 30px;font-size: 26px;color: #f7f7f7;}
    .userInfo{margin-left: 20px;line-height: 3vw;position: absolute;bottom: 3vw; left: 0;}
    .username{float: left;margin-left: 8px;font-size: 20px;color: #f7f7f7;}
    .secondTitle{float: left;margin-left: 30px;font-size: 21px;color: #f7f7f7;margin-top: 2vw;}
    .items{border:1px solid #e8e8e8;margin:0 auto 20px;height:auto;overflow:auto;width:48%;border-radius:8px;float: left;margin-right: 1%;}
  }
  

</style>



// WEBPACK FOOTER //
// src/pages/pc/shop.vue